// client/src/components/agent/ContactsView.jsx
import { useState, useEffect } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

export default function ContactsView({ token, customFields }) {
  const [contacts, setContacts] = useState([]);
  const [search, setSearch] = useState('');
  const isMobile = useIsMobile();
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    fetch('/api/agent/contacts', { headers }).then((r) => r.json()).then(setContacts).catch(() => {});
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = contacts.filter((c) =>
    c.id.includes(search) ||
    Object.values(c.custom || {}).some((v) => String(v).toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div style={{ flex: 1, padding: isMobile ? '1rem' : '1.5rem', overflowY: 'auto', minWidth: 0 }}>
      <div style={{ display: 'flex', flexWrap: isMobile ? 'wrap' : 'nowrap', gap: isMobile ? '0.6rem' : 0, justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.2rem' }}>
        <h2 style={{ color: theme.colors.primary, fontSize: '1.1rem', margin: 0 }}>Todos los contactos</h2>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="🔍 Buscar número o campo..."
          style={{
            padding: '7px 12px', borderRadius: '8px', background: theme.colors.background,
            border: `1px solid ${theme.colors.border}`, color: theme.colors.text,
            outline: 'none', fontSize: '0.85rem', width: isMobile ? '100%' : '220px',
            boxSizing: 'border-box',
          }}
        />
      </div>
      {filtered.length === 0 ? (
        <p style={{ color: theme.colors.textMuted }}>Sin contactos.</p>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
            <thead>
              <tr style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
                <th style={{ textAlign: 'left', padding: '8px 12px', color: theme.colors.textMuted }}>Número</th>
                {customFields.map((f) => (
                  <th key={f.id} style={{ textAlign: 'left', padding: '8px 12px', color: theme.colors.textMuted }}>{f.name}</th>
                ))}
                <th style={{ textAlign: 'left', padding: '8px 12px', color: theme.colors.textMuted }}>Listas</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c) => (
                <tr key={c.id} style={{ borderBottom: `1px solid ${theme.colors.border}` }}>
                  <td style={{ padding: '8px 12px', color: theme.colors.text }}>{c.id}</td>
                  {customFields.map((f) => (
                    <td key={f.id} style={{ padding: '8px 12px', color: theme.colors.textMuted }}>
                      {c.custom?.[f.name] || '—'}
                    </td>
                  ))}
                  <td style={{ padding: '8px 12px', color: theme.colors.textMuted }}>
                    {Array.isArray(c.list_contact) ? c.list_contact.length : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
